var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { getNestedValue } from '../../utils';
import { DatePicker } from '@progress/kendo-react-dateinputs';
var TreeListDateEditor = /** @class */ (function (_super) {
    __extends(TreeListDateEditor, _super);
    function TreeListDateEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange({
                    dataItem: _this.props.dataItem,
                    level: _this.props.level,
                    field: _this.props.field,
                    syntheticEvent: event.syntheticEvent,
                    value: event.value
                });
            }
        };
        return _this;
    }
    /**
     * @hidden
     */
    TreeListDateEditor.prototype.render = function () {
        var defaultRendering = (React.createElement("td", { style: this.props.style, className: this.props.className },
            React.createElement(DatePicker, { width: "100%", value: getNestedValue(this.props.field, this.props.dataItem), onChange: this.onChange })));
        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    };
    return TreeListDateEditor;
}(React.Component));
export default TreeListDateEditor;
//# sourceMappingURL=TreeListDateEditor.js.map